import React from 'react';

const ShoppingCartSVG = () => (
	<svg
		width="188"
		height="188"
		viewBox="0 0 188 188"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<style>{`
          :root {
      --speed: 4s;
      --width: 242px;
    }

    @keyframes cartBounce {
      0% {}

      20% {
        transform: translateY(7px);
      }
    }

    @keyframes scaleIn {
      0% {
        opacity: 0;
        transform: scale(0.1) rotateZ(20deg);
      }

      90% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }

    @keyframes delayAnimation {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 1;
      }

      50.01% {
        opacity: 0;
      }

      100% {
        opacity: 0;
      }
    }

    @keyframes delayAnimationAlternate {
      0% {
        opacity: 0;
      }

      50% {
        opacity: 0;
      }

      50.01% {
        opacity: 1;
      }

      100% {
        opacity: 1;
      }
    }

    #DoorSymbol {
      /* animation: scaleIn 1s infinite, delayAnimationAlternate 2s infinite; */
    }

    #WindowSymbol {
      /*      animation: scaleIn 1s infinite, delayAnimation 2s infinite; */
    }

    #MaskShape,
    #Cart {
      animation: cartBounce 1s ease infinite;
      animation-delay: 0.8s;
    }
    `}</style>

		<defs>
			<pattern
				id="pattern"
				width="4"
				height="4"
				patternUnits="userSpaceOnUse"
				patternTransform="rotate(45 50 50)"
			>
				<line stroke="#930011" strokeWidth="3px" y2="5" />
			</pattern>
		</defs>

		<g id="Add to cart">
			<g id="Inner">
				<g id="Shadow">
					<mask
						id="mask0_1266_25557"
						style={{maskType: 'alpha'}}
						maskUnits="userSpaceOnUse"
					>
						<ellipse cx="91" cy="144" rx="40" ry="7" fill="black" id="maskShape" />
					</mask>
					<rect
						x="0"
						y="0"
						width="100%"
						height="100%"
						mask="url(#mask0_1266_25557)"
						fill="url(#pattern)"
					></rect>
				</g>

				<g id="Cart">
					<path
						id="Vector"
						d="M71.8818 93.6982L80.0172 110.561H101.317L110.562 93.6982H71.8818ZM69.663 89.2607H113.23C114.362 89.2607 115.224 89.7784 115.815 90.8138C116.405 91.8492 116.405 92.8846 115.813 93.9201L105.829 111.892C105.286 112.829 104.582 113.581 103.716 114.148C102.851 114.715 101.903 114.998 100.873 114.998H78.4641L74.3224 122.69H110.636V127.127H74.988C72.9172 127.127 71.4257 126.437 70.5135 125.057C69.6014 123.676 69.6137 122.123 70.5505 120.397L75.2839 111.67L64.0422 87.8555H58.2734V83.418H66.9266L69.663 89.2607Z"
						fill="white"
					/>
				</g>
				<g id="Wheels">
					<path
						d="M71.9555 141.941C72.9909 142.986 74.243 143.509 75.7118 143.509C77.1806 143.509 78.4379 142.992 79.4837 141.956C80.5295 140.921 81.0523 139.669 81.0523 138.2C81.0523 136.731 80.5346 135.474 79.4992 134.428C78.4638 133.382 77.2117 132.859 75.7429 132.859C74.2741 132.859 73.0168 133.377 71.971 134.412C70.9252 135.448 70.4023 136.7 70.4023 138.169C70.4023 139.638 70.9201 140.895 71.9555 141.941Z"
						fill="white"
					/>
					<path
						d="M101.539 141.941C102.574 142.986 103.826 143.509 105.295 143.509C106.764 143.509 108.021 142.992 109.067 141.956C110.113 140.921 110.636 139.669 110.636 138.2C110.636 136.731 110.118 135.474 109.083 134.428C108.047 133.382 106.795 132.859 105.326 132.859C103.857 132.859 102.6 133.377 101.554 134.412C100.509 135.448 99.9857 136.7 99.9857 138.169C99.9857 139.638 100.503 140.895 101.539 141.941Z"
						fill="white"
					/>
				</g>
				<mask
					id="mask1_1279_35904"
					style={{maskType: 'alpha'}}
					maskUnits="userSpaceOnUse"
					x="20"
					y="20"
					width="147"
					height="92"
				>
					<path
						id="MaskShape"
						d="M20 20H167V112H118.509V89.2595H65.0797V112H20V20Z"
						fill="black"
					/>
				</mask>
				<g mask="url(#mask1_1279_35904)">
					<g id="Items">
						<g id="WindowGroup">
							<animateMotion
								id="animateWindowMove"
								dur="1s"
								repeatCount="1"
								begin="1;animateWindowMove.end+1"
							>
								<mpath href="#WindowPath" />
							</animateMotion>

							<animateTransform
								attributeName="transform"
								attributeType="XML"
								type="rotate"
								from="-40"
								to="20"
								dur="1s"
								repeatCount="1"
								begin="1;animateWindowMove.end+1"
							/>

							<animateTransform
								attributeName="transform"
								attributeType="XML"
								additive="sum"
								type="scale"
								from="0.1"
								to="1.1"
								dur="1s"
								repeatCount="1"
								begin="1;animateWindowMove.end+1"
							/>

							<animate
								attributeName="opacity"
								values="0;0.7;1"
								dur="1s"
								repeatCount="1"
								begin="1;animateWindowMove.end+1"
							/>

							<g transform="translate(-30, -70)" id="WindowSymbol">
								<path
									id="Vector_2"
									d="M14 95V59H46V95H14ZM17 75.5H28V73.5H32V75.5H43V62H17V75.5ZM17 92H43V78.5H17V92Z"
									fill="white"
								/>
							</g>
						</g>

						<path
							id="DoorPath"
							d="M151.875 82.1391C151.875 82.1391 160.424 49.541 128.363 45.266C96.3023 40.991 88.2891 119.541 88.2891 119.541"
							stroke="none"
							fill="none"
						/>

						<path
							id="WindowPath"
							d="M29.5079 67.1794C29.5079 67.1794 20.9588 34.5813 53.0199 30.3063C85.0809 26.0313 92.9102 119.543 92.9102 119.543"
							stroke="none"
						/>

						<g id="DoorGroup">
							<animateMotion
								id="animateDoorMove"
								dur="1s"
								repeatCount="1"
								begin="0;animateDoorMove.end+1"
							>
								<mpath href="#DoorPath" />
							</animateMotion>

							<animateTransform
								attributeName="transform"
								attributeType="XML"
								type="rotate"
								from="40"
								to="-20"
								dur="1s"
								repeatCount="indefinite"
							/>

							<animateTransform
								attributeName="transform"
								attributeType="XML"
								additive="sum"
								type="scale"
								from="0.1"
								to="1.1"
								dur="1s"
								repeatCount="indefinite"
							/>

							<animate
								attributeName="opacity"
								values="0;0.7;1"
								dur="1s"
								repeatCount="indefinite"
							/>

							<g transform="translate(-150, -90)" id="DoorSymbol">
								<path
									d="M131 110V107H135V77C135 76.2 135.3 75.5 135.9 74.9C136.5 74.3 137.2 74 138 74H160C160.8 74 161.5 74.3 162.1 74.9C162.7 75.5 163 76.2 163 77V107H167V110H131ZM160 107V77H138V107H160ZM153.35 93.55C153.832 93.55 154.235 93.3872 154.561 93.0615C154.887 92.7355 155.05 92.3317 155.05 91.85C155.05 91.3683 154.887 90.9645 154.561 90.6385C154.235 90.3128 153.832 90.15 153.35 90.15C152.868 90.15 152.465 90.3128 152.139 90.6385C151.813 90.9645 151.65 91.3683 151.65 91.85C151.65 92.3317 151.813 92.7355 152.139 93.0615C152.465 93.3872 152.868 93.55 153.35 93.55Z"
									fill="white"
								/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default ShoppingCartSVG;
